<template>
    <div>
        <h3>フォローとお気に入り</h3>
        <div>
            <p>
                ログインしていれば、気に入った作家さんをフォローしたり、作品をお気に入りに追加することができます。
                フォローしたことやお気に入りに追加したことは、作家さんや他の読者にはわかりません。
            </p>
            <h4>フォローする</h4>
            <p>
                本棚のトップページで作家さんをフォローできます。
                フォローした作家さんはフォロー一覧にリストされ、その作家さんの作品が更新されれば通知欄に表示されます。
            </p>
            <h4>お気に入りに追加する</h4>
            <p>
                本棚にリストされた作品の「お気に入りに追加」ボタンか、本文サイドバーの「お気に入りに追加」ボタンから、
                小説をお気に入りに追加することができます。
            </p>
            <p>
                現時点ではお気に入り作品を分類する機能はありません（予定中です）。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "フォローとお気に入り | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>